export default "__VITE_ASSET__8710d4d5__"